import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    textEditor: {
      border: `1px solid ${theme.gray200}`,
      borderRadius: "4px",
    },
    menuBar: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: theme.spacing(2, 8),
      borderBottom: `1px solid ${theme.gray200}`,
      backgroundColor: theme.gray50,
    },
    buttonsGroup: {
      display: "flex",
      gap: theme.spacing(8),
    },
    menuBarButton: {
      width: "20px",
      height: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(1),
      outline: "none",
      background: "none",
      border: "none",
      cursor: "pointer",
    },
    icon: {
      width: "16px",
      height: "16px",
    },
    strokeMedium: {
      "& path": {
        strokeWidth: 1.5,
      },
    },
    isActive: {
      background: theme.white50,
      borderRadius: "4px",
      boxShadow: "0px 4px 4px -2px rgba(24, 39, 75, 0.06)",
    },
    verticalLine: {
      width: "1px",
      alignSelf: "stretch",
      backgroundColor: theme.gray200,
    },
    ProseMirror: {
      padding: theme.spacing(0, 7),
      fontSize: "16px",
      outline: "none",

      "& :focus": {
        outline: "none",
      },

      "ul, ol": {
        padding: theme.spacing(0, 8),
      },

      "& h1": {
        lineHeight: 1.1,
      },

      "& code": {
        backgroundColor: "rgba(97, 97, 97, 0.2)",
        color: "#616161",
        padding: theme.spacing(2),
        borderRadius: "4px",
      },

      "& p.is-editor-empty:first-child::before": {
        color: theme.gray500,
        content: "attr(data-placeholder)",
        float: "left",
        height: 0,
        pointerEvents: "none",
      },
    },
  }),
);
